module.exports = __webpack_public_path__ + "static/img/10areaB_08.4935b24.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_08.png
// module id = 1078
// module chunks = 1